import React from "react";
import { MenuItem, Stack, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import UserHint from "../../../../../../../../components/display/UserHint";

export const formatDurationLabel = (totalMins) => {
  const hours = Math.floor(totalMins / 60);
  const mins = totalMins % 60;
  if (hours === 0) return `${mins} min`;
  if (mins === 0) return `${hours} h`;
  return `${hours} h ${mins} min`;
};

export default function ServiceDurationForm({
  name = "duration",
  label = "Duration",
  defaultValue = 30,
  hint = null,
  testId,
}) {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors },
  } = useFormContext();

  // Generate options: 15, 30, 45 ... 120 (2 hours)
  const durationOptions = Array.from({ length: 8 }, (_, i) => (i + 1) * 15);

  return (
    <Stack direction={"column"} spacing={1} sx={{ width: "100%" }}>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        rules={{ required: t("FieldRequired") }}
        render={({ field }) => (
          <TextField
            {...field}
            select
            label={t(label)}
            fullWidth
            error={!!errors[name]}
            helperText={errors[name]?.message || ""}
            SelectProps={{
              SelectDisplayProps: testId && { "data-testid": testId },
            }}
          >
            {durationOptions.map((option) => (
              <MenuItem
                key={option}
                value={option}
                data-testid={testId && `${testId}.option.${option}`}
              >
                {formatDurationLabel(option)}
              </MenuItem>
            ))}
          </TextField>
        )}
      />
      {hint ? (
        <UserHint
          hint={hint}
          sx={{
            fontSize: "0.85rem",
          }}
        />
      ) : null}
    </Stack>
  );
}
